const DAWS = [
  "Logic Pro",
  "Ableton Live",
  "FL Studio",
  "Pro Tools",
  "Cubase",
  "Studio One",
  "LUNA",
  "Reaper",
  "Reason",
  "Bitwig Studio",
  "GarageBand",
  "Nuendo",
];

export default DAWS;
